import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 16;

export const migration_15_16:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            let pagesItemsOrdered:string[] = [];
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                pagesItemsOrdered.push(page.id);
                page.overlays = [];
            });

            designState.surface.pagesItemsOrdered = pagesItemsOrdered;
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
